<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CTableWrapper :items="getUsers" :itemsPerPage="itemsPerPage">
          <template #header>
            <CIcon name="cil-grid"/> Anzahl Kunden <strong>({{ getUsers.length }})</strong>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>

<script>

  import CTableWrapper from './../base/CustomerUserTable'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "List",
    components: {
      CTableWrapper
    },
    data:()=> ({
      itemsPerPage: 25

    }),
    methods: {
      ...mapActions('user', [
        'loadUsers'
      ])
    },

    created() {
      this.loadUsers('customer')
    },

    computed: {
      ...mapGetters('user', [
        'getUsers'
      ])
    }
  }
</script>

<style scoped>

</style>
